import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const ContainerMain = styled.div`
    width: 100%;
    aspect-ratio: 1 / 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${props => props.theme.colors.neutralBg};
    border-radius: 16px;
    position: relative;
    overflow: hidden;
    margin-bottom: 16px;

    img {
       object-fit: contain;
       width: 100%;
       height: 100%;
       padding: 24px;
       box-sizing: border-box;
    }
`;

export const ContainerSecundaryImages = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
`;

export const ContainerSmallImage = styled.div`
    aspect-ratio: 1 / 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${props => props.theme.colors.neutralBg};
    border: 2px solid transparent;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: border-color 0.2s;

    &:hover {
        border-color: ${props => props.theme.colors.primary};
    }

    img {
        object-fit: contain;
        width: 100%;
        height: 100%;
        padding: 8px;
        box-sizing: border-box;
    }
`;
